"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var location = {
    assign: function (url) {
        window.location.assign(url);
    },
    reload: function () {
        window.location.reload();
    },
    get href() {
        return window.location.href;
    },
    get pathname() {
        return window.location.pathname;
    },
    get hash() {
        return window.location.hash;
    },
    get origin() {
        return window.location.origin;
    },
};
exports.default = location;
//# sourceMappingURL=wrapped_location.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/lib/wrapped_location.js
// module id = ohwC
// module chunks = 20 21 22